<template>
    <section class="section">
        <div class="container">
            <div class="hero has-text-centered">
                <div class="hero-title">
                    <h1 class="title">The page you are looking for does not exist.</h1>
                    <h1 class="title">Sorry.</h1>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "PageNotFound"
    }
</script>

<style scoped>

</style>